<template>
  <div>
    <v-card tile flat class="hidden-md-and-down">
      <v-parallax
      v-if="homePageServices.image"
        :src="baseURL+homePageServices.image"
        gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.5)"
         style="min-height:500px!important;max-height:1200px!important"
      >
        <v-layout pt-15 class="overlayShade" wrap>
          <v-flex xs12 lg12>
            <v-layout py-3 wrap>
              <v-flex xs12 text-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    color: #ffffff;
                    font-size: 38px;
                    letter-spacing: 2px;
                  "
                >
                  SERVICES PROVIDED
                </span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex lg1> </v-flex>
              <v-flex text-center xs12 lg10>
                <span
                  style="
                    font-family: poppinsregular;
                    color: #ffffff;
                    font-size: 16px;
                    letter-spacing: 2px;
                    line-height: 2.6;
                  "
                >
                  {{homePageServices.text}}
                
                </span>
              </v-flex>
              <v-flex lg1> </v-flex>
            </v-layout>
            <v-layout v-if="services.length>0" wrap>
              <v-flex xs12 lg12>
                <v-layout pt-12 wrap>
                  <template v-for="(item, i) in services">
                    <v-flex py-8 pa-6 :key="i" md6 xs12 lg3>
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card tile flat color="transparent" to="/services">
                            <v-layout wrap>
                              <v-flex xs12 lg12>
                                <v-layout wrap>
                                  <v-flex text-center xs12 lg12>
                                    <span
                                      style="
                                        font-family: poppinsregular;
                                        color: #ffffff;
                                        font-size: 16px;
                                        letter-spacing: 2px;
                                      "
                                    >
                                      <v-icon x-large color="#ffffff">mdi-hvac</v-icon>
                                    </span>
                                  </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                  <v-flex text-center xs12 lg12>
                                    <span
                                      style="
                                        font-family: poppinsregular;
                                        color: #ffffff;
                                        font-size: 22px;
                                        letter-spacing: 2px;
                                      "
                                    >
                                      {{item.name}}
                                    </span>
                                  </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                  <v-flex text-justify xs12 lg12>
                                    <span
                                      style="
                                        font-family: poppinsregular;
                                        color: #ffffff;
                                        font-size: 14px;
                                        letter-spacing: 1px;
                                      "
                                    >
                                      <!-- {{ item.text }} -->
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-layout pb-5 wrap>
                              <v-flex text-center xs12 lg12>
                                <v-fade-transition>
                                  <v-overlay
                                    v-if="hover"
                                    absolute
                                    color="#e7ab5f"
                                  >
                                    <!-- <span
                                      style="
                                        font-family: poppinsbold;
                                        color: #e7ab5f;
                                        font-size: 28px;
                                        letter-spacing: 1px;
                                      "
                                    >
                                      <v-icon large color="#e7ab5f"
                                        >mdi-magnify</v-icon
                                      >
                                      View More
                                    </span> -->
                                  </v-overlay>
                                </v-fade-transition>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </template>
                      </v-hover>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-parallax>
    </v-card>
    <v-card class="hidden-lg-and-up">
      <v-parallax
      v-if="homePageServices.image"
        :src="baseURL+homePageServices.image"
        gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.5)"
        height="700px"
      >
        <v-layout pt-12 class="overlayShade" wrap>
          <v-flex xs12 lg12>
            <v-layout py-3 wrap>
              <v-flex xs12 text-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    color: #ffffff;
                    font-size: 38px;
                    letter-spacing: 2px;
                  "
                >
                  SERVICES PROVIDED
                </span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex lg1> </v-flex>
              <v-flex text-center xs12 lg10>
                <span
                  style="
                    font-family: poppinsregular;
                    color: #ffffff;
                    font-size: 16px;
                    letter-spacing: 2px;
                  "
                >
                  {{homePageServices.text}}
                </span>
              </v-flex>
              <v-flex lg1> </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 lg12>
                <v-layout wrap>
                  <template v-for="(item, i) in services">
                    <v-flex py-8 pa-6 :key="i" md6 xs12 lg3>
                      <v-layout wrap>
                        <v-flex xs12 lg12>
                          <v-layout wrap>
                            <v-flex text-center xs12 lg12>
                              <span
                                style="
                                  font-family: poppinsregular;
                                  color: #ffffff;
                                  font-size: 16px;
                                  letter-spacing: 2px;
                                "
                              >
                                <v-icon x-large color="#ffffff"> mdi-hvac</v-icon>
                              </span>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex text-center xs12 lg12>
                              <span
                                style="
                                  font-family: poppinsregular;
                                  color: #ffffff;
                                  font-size: 22px;
                                  letter-spacing: 2px;
                                "
                              >
                                {{ item.name}}
                              </span>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex text-justify xs12 lg12>
                              <span
                                style="
                                  font-family: poppinsregular;
                                  color: #ffffff;
                                  font-size: 14px;
                                  letter-spacing: 1px;
                                "
                              >
                                <!-- {{ item.text }} -->
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout pb-5 wrap>
                        <v-flex text-center xs12 lg12>
                          <v-btn color="#e7ab5f" to="/services"
                            ><span
                              style="
                                font-family: poppinsregular;
                                color: #ffffff;
                                font-size: 14px;
                                letter-spacing: 1px;
                              "
                              >View More
                            </span></v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-parallax>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      services:[],
      homePageServices:{},
    };
  },
    mounted: function () {
    this.getServices();
    this.getAbout();
  },
  methods: {
    getServices() {
      axios({
        method: "GET",
        url: "/service/providers/list",
      })
        .then((response) => {
          if(response.data.status)
            var serviceData = {};
            serviceData = response.data.data;
            for (var i = 0; i < serviceData.length; i++) {
              if (serviceData[i].text) {
                this.services.push(serviceData[i]);
              }
            }
        })
        .catch(() => {});
    },
    getAbout() {
      axios({
        method: "GET",
        url: "/homepage/view",
      })
        .then((response) => {
          if(response.data.status)
          this.homePageServices = response.data.data.services;
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.overlayShade {
  background-color: rgba(0, 0, 0, 0.6);
}
</style>